export const App: React.FC = () => (
  <div className="flex content-center justify-center mt-24 sm:mt-48">
    <h1 className="p-12 sm:p-24 text-4xl sm:rounded-lg shadow-md shadow-sky-200 bg-white text-sky-800 text-center font-bold">
      W👋ves of Traveling
    </h1>
  </div>
);
